import React, { PureComponent } from 'react'
import CountUp from 'react-countup';
import * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react';
//import { Area, AreaChart, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend
);

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div className="custom-tooltip" style={{
                backgroundColor: '#ebe7e6', borderRadius: 5,
                color: "black", paddingLeft: 4, paddingRight: 4,
                paddingTop: 1, alignItems: 'center', justifyContent: 'center'
            }}>
                <p className="label">{`${label} : ${payload[0].value}`}</p>
            </div>
        );
    }

    return null;
}



export default function AreaLineChart(props) {

    const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a798a'
            }
          }
        },
        xAxis: {
          show: false,
          type: 'category',
          boundaryGap: false,
          data: props.labels,
          showGrid: false,
          splitLine: {
               show: false
            },
        },
        yAxis: {
          show: false,
          type: 'value',
          showGrid: false,
          splitLine: {
               show: false
            },
        },
        series: [
          {
            data: props.datachart,
            type: 'line',
            smooth: true,
            showSymbol: true,
            lineStyle: {
              width: 4,
              color: props.bordercolor
            },
            areaStyle: {
              opacity: 0.5,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: props.backgroundcolor
                }
              ])
            },
            label: {
              show: true,
              position: 'top'
            },
          }
        ]
      };

    

    return (
        <div className='chartBox' >
            <div className="boxInfo">
                <div className="title">

                    {/* <img src={props.icon} width="50" height="50" alt={props.imagealt} /> */}
                    <h3 className='rubik-font' style={{color: 'black', fontWeight: 'lighter' }}>{props.title}</h3>
                </div>
                <h1 className='rubik-font' style={{color: 'black',fontWeight: '400', }}><CountUp end={props.mainstats} /></h1>
            </div>
            <div className="chartInfo">
                <div className="chart">
                    <ReactECharts option={option} style={{ height: '200px', width: '100%' }} />
                </div>
                <div className="texts">
                    <span className="duration rubik-font" style={{color: 'black',fontWeight: 'lighter'}}>Last 5 Months </span>
                </div>
            </div>
        </div>
    )
}






// export default function AreaLineChart(props) {

    


//     //chart options//

//     const options = {
//         responsive: true,
//         tension: 0.4,
//         layout: {
//             padding: 15
//         },
//         plugins: {
//             legend: {
//                 position: 'top',
//                 display: false
//             },
//             title: {
//                 display: true,
    
//             },
//         },
//         scales: {
//             // to remove the labels
//             x: {
//                 display:false,
//               ticks: {
//                 display: false,
//               },
        
//               // to remove the x-axis grid
//               grid: {
//                 drawBorder: false,
//                 display: false,
//               },
//               gridLines: {
//                 drawBorder: false,
//                 display:false
//               }
//             },
//             // to remove the y-axis labels
//             y: {
//                 display: false,
//               ticks: {
//                 display: false,
//                 beginAtZero: true,
//               },
//               // to remove the y-axis grid
//               grid: {
//                 drawBorder: false,
//                 display: false,
//               },
//               gridLines: {
//                 drawBorder: false,
//                 display:false
//               }
//             },
//           },
//     };

//     //chart options//

//     //chart x axis labels//
    
//     const labels = props.labels

//     //chart x axis labels//
    
//     //chart data //
    
//     const data = {
//         labels,
//         datasets: [
//             {
//                 fill: true,
//                 label: false,
//                 data: props.datachart,
//                 borderColor: props.bordercolor,
//                 backgroundColor: props.backgroundcolor,
//             },
//         ],
//     };

//     //chart data //

//     return (
//         <div className='chartBox' >
//             <div className="boxInfo">
//                 <div className="title">

//                     {/* <img src={props.icon} width="50" height="50" alt={props.imagealt} /> */}
//                     <h3 className='rubik-font' style={{color: 'black', fontWeight: 'lighter' }}>{props.title}</h3>
//                 </div>
//                 <h1 className='rubik-font' style={{color: 'black',fontWeight: '400', }}><CountUp end={props.mainstats} /></h1>
//             </div>
//             <div className="chartInfo">
//                 <div className="chart">
//                     <Line options={options} data={data} />
//                 </div>
//                 <div className="texts">
//                     <span className="duration rubik-font" style={{color: 'black',fontWeight: 'lighter'}}>Last 5 Months </span>
//                 </div>
//             </div>
//         </div>
//     )
// }
